(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(35970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ seo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/base/seo.tsx



const Seo = (param)=>{
    let { data  } = param;
    const { title , description , url , thumbnailUrl  } = data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: thumbnailUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:image",
                content: thumbnailUrl
            })
        ]
    });
};
/* harmony default export */ var seo = (Seo);

;// CONCATENATED MODULE: ./src/components/base/index.ts



/***/ }),

/***/ 319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sd": function() { return /* binding */ SwapProvider; },
  "ZP": function() { return /* binding */ context; }
});

// UNUSED EXPORTS: defaultTokenInfoB

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./src/hooks/use-tokens.ts
var use_tokens = __webpack_require__(7331);
// EXTERNAL MODULE: ./src/hooks/use-amplitude.ts + 61 modules
var use_amplitude = __webpack_require__(54341);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/home/use-token-mint-addresses.ts



const PAIR_SEPARATOR = "_";
const useTokenMintAddresses = (initMintAddresses)=>{
    const router = (0,next_router.useRouter)();
    const { isLoading , tokenList , tokenListMap  } = (0,use_tokens/* default */.Co)();
    const [mintAddresses, setMintAddresses] = (0,react.useState)(initMintAddresses);
    (0,react.useEffect)(()=>{
        if (![
            "/",
            "/[pair]"
        ].includes(router.pathname)) return;
        if (!mintAddresses[0] || !mintAddresses[1] || isLoading) return;
        const currentPairQuery = String(window.location.pathname.split("/").pop()).toLowerCase();
        const tokenIn = tokenListMap.get(mintAddresses[0]);
        const tokenOut = tokenListMap.get(mintAddresses[1]);
        if (!tokenIn || !tokenOut) return;
        const newPairQuery = [
            tokenIn.symbol,
            tokenOut.symbol
        ].join(PAIR_SEPARATOR);
        if (currentPairQuery.toLowerCase() === newPairQuery.toLowerCase()) return;
        const searchParams = window.location.search;
        window.history.replaceState({}, "", "/".concat(router.locale, "/").concat(newPairQuery).concat(searchParams));
    }, [
        isLoading,
        tokenListMap,
        mintAddresses,
        router
    ]);
    (0,react.useEffect)(()=>{
        if (isLoading || !tokenList) return;
        const queryPair = String(window.location.pathname.split("/").pop()).toLowerCase();
        const pairs = queryPair.split(PAIR_SEPARATOR);
        if (pairs.length !== 2) return;
        const [queryTokenIn, queryTokenOut] = pairs;
        const foundTokenIn = tokenList.find((t)=>t.token_symbol.toLowerCase() === queryTokenIn);
        const foundTokenOut = tokenList.find((t)=>t.token_symbol.toLowerCase() === queryTokenOut);
        if (!foundTokenIn || !foundTokenOut) return;
        setMintAddresses((prevMintAddresses)=>{
            const [prevInAddr, prevOutAddr] = prevMintAddresses;
            const newDefaultInAddr = (foundTokenIn === null || foundTokenIn === void 0 ? void 0 : foundTokenIn.coin_address) || prevInAddr;
            const newDefaultOutAddr = (foundTokenOut === null || foundTokenOut === void 0 ? void 0 : foundTokenOut.coin_address) || prevOutAddr;
            const isDuplicated = newDefaultInAddr === newDefaultOutAddr;
            if (isDuplicated) {
                if (newDefaultInAddr === prevInAddr || newDefaultInAddr === prevOutAddr) {
                    return prevMintAddresses;
                }
                return [
                    newDefaultInAddr,
                    prevOutAddr
                ];
            }
            return [
                newDefaultInAddr,
                newDefaultOutAddr
            ];
        });
    }, [
        isLoading,
        tokenList
    ]);
    return {
        mintAddresses,
        setMintAddresses
    };
};
/* harmony default export */ var use_token_mint_addresses = (useTokenMintAddresses);

// EXTERNAL MODULE: ./src/providers/language/index.tsx + 1 modules
var language = __webpack_require__(59915);
;// CONCATENATED MODULE: ./src/components/home/context.tsx







const defaultTokenInfoA = {
    nickName: "tokenA",
    chainId: 101,
    address: use_tokens/* RENEC_MINT_ADDRESS */.vV,
    name: use_tokens/* RENEC */.A7,
    decimals: 9,
    symbol: use_tokens/* RENEC */.A7,
    logoURI: "https://remitano.com/coins/renec.png"
};
const defaultTokenInfoB = {
    nickName: "tokenA",
    chainId: 101,
    address: use_tokens/* REUSD_MINT_ADDRESS */.Df,
    name: use_tokens/* REUSD */.ZP,
    decimals: 9,
    symbol: use_tokens/* REUSD */.ZP,
    logoURI: "https://raw.githubusercontent.com/renec-chain/rpl-token-registry/master/assets/mainnet/4Q89182juiadeFgGw3fupnrwnnDmBhf7e7fHWxnUP3S3/logo.png"
};
const initContextState = {
    inputMintAddress: use_tokens/* REUSD */.ZP,
    setInputMintAddress: ()=>null,
    outputMintAddress: use_tokens/* REUSD */.ZP,
    setOutputMintAddress: ()=>null,
    switchMintAddresses: ()=>null,
    tokenIn: defaultTokenInfoA,
    tokenOut: defaultTokenInfoB,
    isLoading: false
};
const SwapContext = /*#__PURE__*/ (0,react.createContext)(initContextState);
const DEFAULT_MINT_ADDRESSES_BY_LANG_MAP = {
    vi: [
        "",
        use_tokens/* REVND_MINT_ADDRESS */.PW
    ],
    vn: [
        "",
        use_tokens/* REVND_MINT_ADDRESS */.PW
    ],
    ng: [
        "",
        use_tokens/* RENGN_MINT_ADDRESS */.f_
    ],
    en: [
        "",
        use_tokens/* RENEC_MINT_ADDRESS */.vV
    ]
};
const SwapProvider = (param)=>{
    let { children  } = param;
    const { isLoading: isLoadingSettings  } = (0,use_settings/* useSettings */.r)();
    const { getTokenInfo , isLoading: isLoadingTokens  } = (0,use_tokens/* useTokens */.rU)();
    const amplitude = (0,use_amplitude/* default */.Z)();
    const { isoCode , lang  } = (0,react.useContext)(language/* LanguageContext */.A);
    const defaultMintAddressByLangMap = (0,react.useMemo)(()=>{
        if (isoCode && Object.keys(DEFAULT_MINT_ADDRESSES_BY_LANG_MAP).includes(isoCode === null || isoCode === void 0 ? void 0 : isoCode.toLowerCase())) {
            return DEFAULT_MINT_ADDRESSES_BY_LANG_MAP[(isoCode === null || isoCode === void 0 ? void 0 : isoCode.toLowerCase()) || lang];
        } else {
            return DEFAULT_MINT_ADDRESSES_BY_LANG_MAP["en"];
        }
    }, [
        isoCode,
        lang
    ]);
    const { mintAddresses , setMintAddresses  } = use_token_mint_addresses(defaultMintAddressByLangMap);
    const [inputMintAddress, outputMintAddress] = (0,react.useMemo)(()=>mintAddresses, [
        mintAddresses
    ]);
    const [tokenIn, tokenOut] = (0,react.useMemo)(()=>[
            inputMintAddress ? getTokenInfo(inputMintAddress) : undefined,
            outputMintAddress ? getTokenInfo(outputMintAddress) : undefined
        ], [
        getTokenInfo,
        inputMintAddress,
        outputMintAddress
    ]);
    const switchMintAddresses = (0,react.useCallback)(()=>{
        amplitude.track(use_amplitude/* EVENT_NAMES.swap_switch_token */.K.swap_switch_token, {
            from_token: tokenOut === null || tokenOut === void 0 ? void 0 : tokenOut.symbol,
            to_token: tokenIn === null || tokenIn === void 0 ? void 0 : tokenIn.symbol
        });
        setMintAddresses((param)=>{
            let [a, b] = param;
            return [
                b,
                a
            ];
        });
    }, [
        amplitude,
        tokenIn,
        tokenOut,
        setMintAddresses
    ]);
    const setInputMintAddress = (0,react.useCallback)((mintAddress)=>{
        setMintAddresses((param)=>{
            let [a, b] = param;
            return [
                mintAddress,
                mintAddress === b ? a : b
            ];
        });
        const token = getTokenInfo(mintAddress);
        amplitude.track(use_amplitude/* EVENT_NAMES.swap_select_from_token */.K.swap_select_from_token, {
            token_name: token === null || token === void 0 ? void 0 : token.symbol
        });
    }, [
        amplitude,
        getTokenInfo,
        setMintAddresses
    ]);
    const setOutputMintAddress = (0,react.useCallback)((mintAddress)=>{
        setMintAddresses((param)=>{
            let [a, b] = param;
            return [
                mintAddress === a ? b : a,
                mintAddress
            ];
        });
        const token = getTokenInfo(mintAddress);
        amplitude.track(use_amplitude/* EVENT_NAMES.swap_select_to_token */.K.swap_select_to_token, {
            token_name: token === null || token === void 0 ? void 0 : token.symbol
        });
    }, [
        amplitude,
        getTokenInfo,
        setMintAddresses
    ]);
    (0,react.useEffect)(()=>{
        if (!tokenIn && isoCode) setMintAddresses(defaultMintAddressByLangMap);
    }, [
        defaultMintAddressByLangMap,
        isoCode,
        setMintAddresses,
        tokenIn
    ]);
    const contextValue = (0,react.useMemo)(()=>{
        return {
            inputMintAddress,
            setInputMintAddress,
            outputMintAddress,
            setOutputMintAddress,
            switchMintAddresses,
            tokenIn,
            tokenOut,
            isLoading: isLoadingSettings || isLoadingTokens
        };
    }, [
        inputMintAddress,
        setInputMintAddress,
        outputMintAddress,
        setOutputMintAddress,
        switchMintAddresses,
        tokenIn,
        tokenOut,
        isLoadingSettings,
        isLoadingTokens
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapContext.Provider, {
        value: contextValue,
        children: children
    });
};
SwapContext.displayName = "SwapContext";
/* harmony default export */ var context = (SwapContext);


/***/ }),

/***/ 35970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_home_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(319);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74069);
/* harmony import */ var _components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13171);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28254);






const Home = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(259), __webpack_require__.e(45), __webpack_require__.e(376), __webpack_require__.e(589), __webpack_require__.e(844), __webpack_require__.e(728), __webpack_require__.e(798)]).then(__webpack_require__.bind(__webpack_require__, 6798)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6798)
            ]
    },
    ssr: false
});
const Index = ()=>{
    const trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base__WEBPACK_IMPORTED_MODULE_4__/* .Seo */ .p, {
                data: {
                    title: trans.meta.home.title,
                    description: trans.meta.home.description,
                    thumbnailUrl: trans.meta.home.thumb
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_5__/* .MainLayout */ .Z, {
                hasNautilus: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_home_context__WEBPACK_IMPORTED_MODULE_2__/* .SwapProvider */ .sd, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Home, {})
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [495,254,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);